import { attributes, AttributesMixin, define, Model, type } from "@type-r/models";
import { restfulIO } from "./endpoint";

const EmailString = ( error ) => type(String).check(x => {
    if (x && x.length > 0) {
        var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(x);
    }
    return false;
  }, error);

export const NotificationSubscriptionType = attributes({
    name: String,
    description: String,
    createdOn: type(Date),
    createdBy: String
});

export interface NotificationSubscription extends AttributesMixin<typeof NotificationSubscription> { }
@define
export class NotificationSubscription extends Model {
    static endpoint = restfulIO('/api/v1/notificationSubscriptions/subscription/');

    static attributes = {
        participantId: Number,
        participantRole: String,
        email: EmailString('Email is required'),
        platformCode: type(String).dontSave,
        createdOn: type(Date),
        updatedOn: type(Date),
        createdBy: String,
        updatedBy: String,
        subscriptions: type([ NotificationSubscriptionType ]).check(x => x.length > 0, 'At least one subscription is requried'),
        errorMessage: type(String).null
    };

}
